<template>
    <div>
        <div class="app-title">
            <div>
                <h2>{{$t('tlt.fm.coolingWater')}}</h2>
                <ul class="app-breadcrumb breadcrumb">
                    <li class="breadcrumb-item"><router-link to="/"><i class="fa fa-home"></i></router-link></li>
                    <li class="breadcrumb-item"><router-link to="/prd/smeltingFurnaceMeasure"><span>{{$t('tlt.furnaceMeasure')}}</span></router-link></li>
                    <li class="breadcrumb-item"><router-link to="/prd/coolingWaterPara"><span>{{$t('tlt.fm.coolingWater')}}</span></router-link></li>
                </ul>
            </div>
            <!-- <div class="col-lg-4">
                <div class="float-lg-right">
                    <button class="btn btn-outline-primary" v-on:click="MMFNew('coolingWaterPara')">
                        <i class="fa fa-fw fa-lg fa-plus"></i>
                        <span class="text">{{ $t("btn.basic.add") }}</span>
                    </button>
                </div>
            </div> -->
        </div>

        <section class="app-content">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionFilter">
                        <div class="card-body">
                            <form class="row">
                                <div class="form-group col-md-2">
                                    <label class="control-label">{{ $t("lbl.basic.startTime") }} :</label>
                                    <mmf-datepicker v-model="startTimeFilter"></mmf-datepicker>
                                </div>
                                <div class="form-group col-md-2">
                                    <label class="control-label">{{ $t("lbl.basic.endTime") }} :</label>
                                    <mmf-datepicker v-model="endTimeFilter"></mmf-datepicker>
                                </div>
                                <div class="form-group col-md-2">
                                    <label class="control-label">{{$t('lbl.fm.locationName')}}：</label>
                                    <select class="form-control" v-model="locNameFilter">
                                        <option value="default">{{$t("lbl.basic.select.one")}}</option>
                                        <option value="冶炼车间一期">{{$t('lbl.basic.plant.smelting1')}}</option>
                                        <option value="冶炼车间二期">{{$t('lbl.basic.plant.smelting2')}}</option>
                                        <option value="冶炼车间三期">{{$t('lbl.basic.plant.smelting3')}}</option>
                                    </select>
                                </div>
                                <div class="form-group col-md-2">
                                    <label class="control-label">{{ $t("lbl.basic.furnaceName") }}：</label>
                                    <select class="form-control" v-model="furnaceNumberFilter">
                                        <option value="default">{{$t("lbl.basic.select.one")}}</option>
                                        <option value="1">{{ $t("opt.furnaceNumber1") }}</option>
                                        <option value="2">{{ $t("opt.furnaceNumber2") }}</option>
                                        <option value="3">{{ $t("opt.furnaceNumber3") }}</option>
                                        <option value="4">{{ $t("opt.furnaceNumber4") }}</option>
                                        <option value="5">{{ $t("opt.furnaceNumber5") }}</option>
                                        <option value="6">{{ $t("opt.furnaceNumber6") }}</option>
                                    </select>
                                </div>
                                <div class="col-lg-12 align-self-end">
                                    <div class="float-lg-right">
                                        <button class="btn btn-outline-secondary mr-1" type="button" v-on:click="MMFClearFilter('coolingWaterPara')">
                                            <i class="fa fa-fw fa-lg fa-eraser"></i>
                                            <span class="text">{{ $t("btn.basic.clear") }}</span>
                                        </button>
                                        <button class="btn btn-primary" type="button" v-on:click="MMFLoadRows('coolingWaterPara')">
                                            <i class="fa fa-fw fa-lg fa-search"></i>
                                            <span class="text">{{ $t("btn.basic.search") }}</span>
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            
            <div id="coolingWaterListTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo" data-parent="#accordionResult">
                        <div class="card-body">
                            <mmf-table entity="coolingWaterPara" inline-actions-disabled singleChoice></mmf-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { createHelpers } from "vuex-map-fields";
import {
  gridFields,
  filterFields
} from "@/model/prd/productionExecution/smelting/CoolingWaterPara";
import MmfTable from "@/components/MmfTable";
import MmfDatepicker from "@/components/MmfDatepicker";

// create a helper to generate getters and setters with namespace
const { mapFields } = createHelpers({
  getterType: "coolingWaterPara/getField",
  mutationType: "coolingWaterPara/updateField"
});
export default {
    name: "coolingWaterParaList",
    data(){
        return {

        }
    },
    components: { MmfTable, MmfDatepicker },
    computed: {
    // generate and add getters and setters using the filter names defined in
    // entity model
    ...mapFields(filterFields),
    ...mapState({
      rows: state => state.coolingWaterPara.rows,
      tableColumns: gridFields,
      entity: state => state.coolingWaterPara.entity,
      checkedItems: state => state.coolingWaterPara.checkedItems,
      showNoResultAlert: state => state.base.showNoResultAlert
    })
    },
    methods: {
    ...mapActions("base", [
      "MMFselectRow",
      "MMFselectAllRows",
      "MMFNew",
      "MMFEdit",
      "MMFLoadRows",
      "MMFDelete",
      "MMFClearFilter"
    ]),
    },
    mounted() {}
}
</script>